// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-widget-access{font-size:21px;font-style:italic;padding:8px;color:#787f87}", ""]);
// Exports
module.exports = exports;
